import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

const useStyles = makeStyles((theme) => ({
  panel: {
    margin: 50,
    display: "flex",
    flexDirection: "column",
    padding: 30,
  },
  card: {
    marginBottom: 40,
    padding: 30,
  },
  title: {
    display: "flex",
    marginBottom: 20,
  },
  titleText: {
    fontSize: 30,
    marginLeft: 20,
  },
  sec: {
    marginTop: 20,
  }
}));

export default function Web() {
    const classes = useStyles();

    return (
      <Box color="text.primary" className={classes.panel}>
          <Card className={classes.card}>
            <CardContent>
              <Box className={classes.title}>
                <img src="/imgs/Mokahr.png" width="40px" height="40px"/>
                <Typography className={classes.titleText}>Full-stack Web dveloper @<Link href="https://www.mokahr.com/" target="_blank">MokaHR</Link></Typography>
              </Box>
              <Typography color="textSecondary">Jun 2018 - Apr 2019</Typography>
              <div className={classes.sec}>
                <Typography>
                  1. Worked at the Web Development Team to develop and maintain the SaaS HR software using <Link href="https://reactjs.org/" target="_blank">React.js</Link>, <Link href="https://nodejs.org/en/" target="_blank">Node.js</Link> and <Link href="https://www.mysql.com/" target="_blank">MySQL</Link>. 
                </Typography>
                <Typography>
                  2. Refactored the MokaHR mobile website to improve the customer experience. 
                </Typography>
              </div>
            </CardContent>
          </Card>
          <Card className={classes.card}>
            <CardContent>
              <Box className={classes.title}>
                <img src="/imgs/IMVU.png" width="40px" height="40px"/> 
                <Typography className={classes.titleText}>Software Engineer Intern @<Link href="https://togetherlabs.com/" target="_blank">IMVU</Link></Typography>
              </Box>
              <Typography color="textSecondary">May 2020 - Aug 2020</Typography>
              <div className={classes.sec}>
                <Typography>
                  1. Interned with Web Team, responsible for developing IMVU Website (<Link href="https://jquery.com/" target="_blank">jQuery</Link>, <Link href="https://backbonejs.org/" target="_blank">Backbone.js</Link>, and <Link href="https://www.php.net/" target="_blank">PHP</Link>) and IMVU Desktop Application (<Link href="https://www.electronjs.org/" target="_blank">Electron.js</Link>).
                </Typography>
                <Typography>
                  2. Developed the "Desktop Application Return Notification" system for IMVU Desktop Application using JavaScript and Electron.js to enhance the customer experience and increase customer stickiness.
                </Typography>
                <Typography>
                  3. Improved VIP UpSell checkout flow to boost sales of in-game credits.
                </Typography>
              </div>
            </CardContent>
          </Card>
      </Box>
    );
}